// Use relative path in production, absolute URL in development
const isLocalhost = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
export const API_BASE_URL = import.meta.env.VITE_API_BASE || (isLocalhost ? 'http://localhost:8000/api/v1' : '/api/v1');

// Get domain base URL (without /api/v1) for image uploads, etc.
export const getApiBaseUrl = () => {
  const fullUrl = API_BASE_URL;
  if (fullUrl.endsWith('/api/v1')) {
    return fullUrl.slice(0, -7);
  }
  return fullUrl;
};

export const API_ENDPOINTS = {
  // Base URL for other endpoints
  BASE_URL: API_BASE_URL,
  
  // Admin endpoints
  ADMIN_DASHBOARD_STATS: `${API_BASE_URL}/admin/dashboard/stats`,
  ADMIN_DASHBOARD_ACCOUNT_TYPES: `${API_BASE_URL}/admin/dashboard/account-type-stats`,
  ADMIN_HIERARCHY_STATS: `${API_BASE_URL}/admin/hierarchy/stats`,
  ADMIN_HIERARCHY_TREE: `${API_BASE_URL}/admin/hierarchy/tree`,
  ADMIN_HIERARCHY_INITIALIZE: `${API_BASE_URL}/admin/hierarchy/initialize`,
  ADMIN_HIERARCHY_INVITE: `${API_BASE_URL}/admin/hierarchy/invite`,
  ADMIN_HIERARCHY_CREATE: `${API_BASE_URL}/admin/hierarchy/create`,
  ADMIN_ROLES: `${API_BASE_URL}/admin/roles`,
  ADMIN_USERS: `${API_BASE_URL}/admin/users`,
  ADMIN_SECURITY_ALERTS: `${API_BASE_URL}/admin/security-alerts`,
  ADMIN_SETTINGS: `${API_BASE_URL}/admin/settings`,
  ADMIN_TRACKING: `${API_BASE_URL}/admin/tracking`,
  ADMIN_CONTRACTS: `${API_BASE_URL}/admin/contracts`,
  
  // Admin Tasks endpoints
  ADMIN_TASKS_STATS: `${API_BASE_URL}/admin/tasks/stats`,
  ADMIN_TASKS_REPORTS: `${API_BASE_URL}/admin/tasks/reports`,
  ADMIN_TASKS_COMPLAINTS: `${API_BASE_URL}/admin/tasks/complaints`,
  ADMIN_TASKS_ISSUES: `${API_BASE_URL}/admin/tasks/issues`,
  ADMIN_TASKS_SUPPORT: `${API_BASE_URL}/admin/tasks/support-tickets`,
  
  // Auth endpoints
  ADMIN_LOGIN: `${API_BASE_URL}/admin/auth/login`,
  ADMIN_ME: `${API_BASE_URL}/admin/me`,
  
  // Properties endpoint
  PROPERTIES: `${API_BASE_URL}/properties`,
  
  // Contracts endpoint (user)
  CONTRACTS: `${API_BASE_URL}/contracts`,
};

export const getAuthHeaders = (): Record<string, string> => {
  // CHỈ DÙNG admin_token - KHÔNG BAO GIỜ DÙNG token hoặc auth_token của user thường
  // Đảm bảo admin system hoàn toàn tách biệt với user system
  const adminToken = localStorage.getItem('admin_token');
  
  const headers: Record<string, string> = {
    'Content-Type': 'application/json'
  };
  
  if (adminToken) {
    headers['Authorization'] = `Bearer ${adminToken}`;
  } else {
    console.warn('[Admin] No admin_token found. User must login through admin login page.');
    // Chỉ xóa admin session để không ảnh hưởng user session của app chính
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_level');
    localStorage.removeItem('admin_user_id');
    localStorage.removeItem('user_id');
  }
  
  return headers;
};

